import { motion } from 'framer-motion';
import { useState } from 'react';

const ContactForm = () => {
  const currentDate = "2025-04-17 12:40:52";
  const currentUser = "UPHARISH24";
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    timestamp: currentDate,
    user: currentUser
  });
  
  const [status, setStatus] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');

    // Create form data object
    const formDataObj = new FormData();
    Object.keys(formData).forEach(key => {
      formDataObj.append(key, formData[key as keyof typeof formData]);
    });

    try {
      const response = await fetch(
        'https://script.google.com/macros/s/AKfycbx6b35vMMLoq4l2gRhixXD9w-D7Vnpz35Kh9l4_7MsryILGTkMZOurVF1_nA4lX0UoiFw/exec',
        {
          method: 'POST',
          body: formDataObj,
          mode: 'no-cors'
        }
      );

      setStatus('success');
      setFormData({ 
        name: '', 
        email: '', 
        phone: '', 
        message: '',
        timestamp: currentDate,
        user: currentUser
      });
    } catch (error) {
      console.error('Submission error:', error);
      setStatus('error');
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-white p-8 rounded-lg shadow-lg max-w-2xl mx-auto"
    >
      <h2 className="text-3xl font-bold text-primary mb-6">Contact Us</h2>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-gray-700 mb-2 font-medium">Name *</label>
          <input
            type="text"
            required
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-all"
            placeholder="Enter your name"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2 font-medium">Email *</label>
          <input
            type="email"
            required
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-all"
            placeholder="Enter your email"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2 font-medium">Phone</label>
          <input
            type="tel"
            pattern="[0-9]{10}"
            value={formData.phone}
            onChange={(e) => setFormData({...formData, phone: e.target.value})}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-all"
            placeholder="Enter your phone number"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2 font-medium">Message *</label>
          <textarea
            required
            value={formData.message}
            onChange={(e) => setFormData({...formData, message: e.target.value})}
            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-all h-32 resize-none"
            placeholder="Type your message here..."
          />
        </div>

        <motion.button
          type="submit"
          disabled={status === 'sending'}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className={`w-full py-3 rounded-lg transition-all duration-300 flex items-center justify-center space-x-2
            ${status === 'sending' 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-gradient-to-r from-primary to-secondary text-white hover:shadow-lg'
            }`}
        >
          {status === 'sending' ? (
            <>
              <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Sending...</span>
            </>
          ) : (
            <>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span>Send Message</span>
            </>
          )}
        </motion.button>

        {status === 'success' && (
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-green-600 text-center bg-green-50 p-3 rounded-lg"
          >
            Message sent successfully! We'll get back to you soon.
          </motion.p>
        )}
        {status === 'error' && (
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-red-600 text-center bg-red-50 p-3 rounded-lg"
          >
            Error sending message. Please try again or contact us directly at vistatech.in@gmail.com
          </motion.p>
        )}
      </form>
    </motion.div>
  );
};

export default ContactForm;